import { useQuery } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import type { MeResponse } from '@atnt/shared';
import { meQuery } from '@/shared/api/auth';

const authedRoute = getRouteApi('/_authed');

/** The signed-in user: live query data, falling back to the snapshot `_authed` put into the route context. */
export function useMe(): MeResponse {
  const { me } = authedRoute.useRouteContext();
  const { data } = useQuery(meQuery);
  return data ?? me;
}

/** Floating-UI offsets are CSS px; convert design px with the current root scale (01-design-system §8). */
export const dp = (n: number) =>
  typeof window === 'undefined' ? n : (n * parseFloat(getComputedStyle(document.documentElement).fontSize)) / 16;
